export default __webpack_public_path__ + "static/side-left-704ad57ca9bc62b59fc399267bd37d21.jpg";